// extracted by mini-css-extract-plugin
export default {"root":"Modal-module_root__BzNGz","overlay":"Modal-module_overlay__Ev2D4","sm":"Modal-module_sm__p8aTi","md":"Modal-module_md__Iry3O"};